//# sourceMappingURL=external_link.mjs.map
/// <reference types="./external_link.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function external_link() {
  return $svg.square(
    24,
    "<path d=\"M10 6.11475V8.11475H5V19.1147H16V14.1147H18V20.1147C18 20.38 17.8946 20.6343 17.7071 20.8219C17.5196 21.0094 17.2652 21.1147 17 21.1147H4C3.73478 21.1147 3.48043 21.0094 3.29289 20.8219C3.10536 20.6343 3 20.38 3 20.1147V7.11475C3 6.84953 3.10536 6.59518 3.29289 6.40764C3.48043 6.2201 3.73478 6.11475 4 6.11475H10ZM21 3.11475V11.1147H19V6.52775L11.207 14.3217L9.793 12.9077L17.585 5.11475H13V3.11475H21Z\" fill=\"currentColor\"/>",
  );
}
